import { useEffect, useRef } from "react";
import type { ChapterId } from "./types";
import { useTour } from "./TourProvider";

/** Start `chapterId` once, the first time `ready` is true on this mount, if
 *  the current reviewer has never completed or skipped it (spec §3, D5) — or
 *  if it is the chapter the previous page's Done armed (the hand-off chain),
 *  whatever its history. An armed chapter is disarmed as it starts. */
export function useTourAutoStart(chapterId: ChapterId, ready: boolean): void {
  const { start, statusOf, nextOf, clearNext, state } = useTour();
  const fired = useRef(false);
  useEffect(() => {
    if (!ready || fired.current) return;
    fired.current = true;
    if (state.active) return;
    const armed = nextOf() === chapterId;
    if (!armed && statusOf(chapterId) !== undefined) return;
    if (armed) clearNext();
    start(chapterId, "auto");
  }, [ready, chapterId, start, statusOf, nextOf, clearNext, state.active]);
}
